import React from 'react';
import { Button } from './ui/Button';
import { Download, Lock, Star, TagIcon } from 'lucide-react';
export function OfferSection() {
  return <section id="offer" className="py-24 bg-transparent text-[#3A3A3A] px-4 text-center" data-id="element-244">
      <div className="max-w-4xl mx-auto" data-id="element-245">
        <div className="mb-12" data-id="element-246">
          <h2 className="text-3xl md:text-4xl font-semibold mb-6 text-[#3A3A3A]" data-id="element-247">
            Recupera el control hoy.
          </h2>
          <p className="text-xl text-[#7A7A7A] font-light" data-id="element-248">
            No necesitas "ser otra persona". Necesitas un protocolo que tu
            cuerpo entienda.
          </p>
        </div>

        <div className="bg-white border border-[#E8E8E6] rounded-3xl p-8 md:p-12 relative overflow-hidden shadow-sm" data-id="element-249">
          {/* Promo badge */}
          <div className="absolute top-4 right-4 bg-[#5BBFB5] text-white text-xs font-bold px-3 py-1.5 rounded-full flex items-center gap-1.5 uppercase tracking-wider" data-id="element-250">
            <TagIcon className="w-3.5 h-3.5" data-id="element-251" />
            Super Promo
          </div>

          <div className="relative z-10" data-id="element-252">
            <div className="flex flex-col lg:flex-row items-center gap-10 mb-10 border-b border-[#E8E8E6] pb-10" data-id="element-253">
              {/* Product Image */}
              <a href="https://pay.hotmart.com/D104310882V?bid=1770407336992" target="_blank" rel="noopener noreferrer" className="shrink-0 relative group" data-id="element-254">
                <img src="https://cdn.magicpatterns.com/uploads/w6xCwDnec1XDHdyMMWNapW/Ansiedad_expres_optimized.png" alt="Ansiedad Exprés Cover" className="relative w-48 rounded-lg shadow-lg rotate-[-2deg] group-hover:rotate-0 transition-transform duration-300 border border-[#E8E8E6] cursor-pointer" data-id="element-255" />
              </a>

              <div className="flex-1 w-full" data-id="element-256">
                <div className="flex flex-col md:flex-row items-center justify-between gap-4 mb-6" data-id="element-257">
                  <div className="text-center md:text-left" data-id="element-258">
                    <h3 className="text-2xl font-semibold text-[#3A3A3A] mb-2" data-id="element-259">
                      Ansiedad Exprés
                    </h3>
                    <p className="text-[#7A7A7A]" data-id="element-260">Ebook Digital</p>
                  </div>
                  <div className="text-center md:text-right" data-id="element-261">
                    <div className="flex items-baseline justify-center md:justify-end gap-3" data-id="element-262">
                      <span className="text-xl font-semibold text-[#7A7A7A] line-through decoration-red-400 decoration-2" data-id="element-263">
                        $29.99
                      </span>
                      <span className="text-4xl font-bold text-[#3A3A3A] tracking-tight" data-id="element-264">
                        $7.99
                      </span>
                      <span className="text-lg font-medium text-[#7A7A7A]" data-id="element-265">
                        USD
                      </span>
                    </div>
                    <div className="flex items-center justify-center md:justify-end gap-2 mt-1" data-id="element-266">
                      <span className="bg-red-50 text-red-500 text-xs font-bold px-2 py-0.5 rounded-full" data-id="element-267">
                        -73% OFF
                      </span>
                      <p className="text-xs text-[#7A7A7A]" data-id="element-268">Pago único</p>
                    </div>
                  </div>
                </div>

                <a href="https://pay.hotmart.com/D104310882V?bid=1770407336992" target="_blank" rel="noopener noreferrer" className="w-full" data-id="element-269">
                  <Button size="lg" className="w-full text-lg py-5" withIcon data-id="element-270">
                    Quiero el protocolo — $7.99 USD
                  </Button>
                </a>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center gap-4 text-sm text-[#7A7A7A]" data-id="element-271">
              <span className="flex items-center gap-1.5" data-id="element-272">
                <Lock className="w-4 h-4" data-id="element-273" /> Pago seguro
              </span>
              <span className="hidden sm:inline text-[#E8E8E6]" data-id="element-274">•</span>
              <span className="flex items-center gap-1.5" data-id="element-275">
                <Download className="w-4 h-4" data-id="element-276" /> Entrega inmediata
              </span>
              <span className="hidden sm:inline text-[#E8E8E6]" data-id="element-277">•</span>
              <span className="flex items-center gap-1.5" data-id="element-278">
                <Star className="w-4 h-4 text-[#5BBFB5]" data-id="element-279" /> 4.9/5 Calificación
              </span>
            </div>
          </div>
        </div>

        <p className="mt-12 text-sm text-[#7A7A7A] max-w-xl mx-auto font-light" data-id="element-280">
          Este producto no sustituye la terapia profesional. Si experimentas
          síntomas severos o crónicos, por favor consulta a un especialista de
          salud mental.
        </p>
      </div>
    </section>;
}